module.exports = __webpack_public_path__ + "img/shoot_00035.fbaad781.png";